var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-splite-flag-wraper",attrs:{"id":"print-pension-wraper"}},[_vm._t("cover"),_c('totalDetail')],2)}
var staticRenderFns = []

export { render, staticRenderFns }